import { VirtualPropertiesRegistry, collectVirtualProperties } from '@core/shared/virtual-properties';
import { ConfigService } from '@core/shared/config';
import { FeatureRegistry } from '@core/shared/feature';
import { DevToolsRegistry } from '../dev-tools';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/feature";
import * as i2 from "@core/shared/config";
import * as i3 from "../dev-tools";
export let VirtualPropertiesFrontendRegistry = /*#__PURE__*/(() => {
  class VirtualPropertiesFrontendRegistry extends VirtualPropertiesRegistry {
    constructor(featureReg, config, debug) {
      const baseFeatures = featureReg.getBaseFeatures();
      const vPropsMap = collectVirtualProperties(baseFeatures);
      super(vPropsMap, config);
      debug.exposeDebugFunction(['Features', 'VirtualProperty Definitions'], () => {
        return vPropsMap;
      });
      debug.exposeDebugFunction(['Features', 'Loaded VirtualProperties'], () => {
        return this.generateDebugData();
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
    }
    static {
      this.ɵfac = function VirtualPropertiesFrontendRegistry_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VirtualPropertiesFrontendRegistry)(i0.ɵɵinject(i1.FeatureRegistry), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: VirtualPropertiesFrontendRegistry,
        factory: VirtualPropertiesFrontendRegistry.ɵfac
      });
    }
  }
  return VirtualPropertiesFrontendRegistry;
})();